import { call, put, select, takeLatest } from 'redux-saga/effects'
import { IntubationService } from '../../intubation/services/intubation.service'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import * as actions from '../store/options.actions'
import { IOptionsResponse } from '../../../common/common.types'
import { getServiceIdSelector } from '../../user/selectors'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* setMallampatiOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const intubationService = new IntubationService(serviceId)
  try {
    const response: IOptionsResponse = yield call([intubationService, intubationService.getMallampatiOptions])
    const { entity } = response
    yield put(actions.setMallampatiOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`setMallampatiOptions() error: ${e}`))
  }
}
export function* setMallampatiOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setMallampatiOptions)
}
